import React from 'react'

function FrontYoutubeIcon({ width, height, className }) {
    return (
        <svg id="Group_12888_3_" data-name="Group 12888 (3)" xmlns="http://www.w3.org/2000/svg" width={width} height={height} className={className} viewBox="0 0 24.272 16.999">
            <path id="Path_21040" data-name="Path 21040" d="M23.736,2.662A3.051,3.051,0,0,0,21.588.514C19.7,0,12.124,0,12.124,0S4.543.016,2.659.529A3.051,3.051,0,0,0,.511,2.678c-.57,3.347-.791,8.446.016,11.659a3.051,3.051,0,0,0,2.148,2.148C4.558,17,12.139,17,12.139,17s7.581,0,9.464-.514a3.051,3.051,0,0,0,2.148-2.148A32.651,32.651,0,0,0,23.736,2.662Z" transform="translate(0)" fill="red" />
            <path id="Path_21041" data-name="Path 21041" d="M25.605,20.091l6.289-3.643-6.289-3.643Z" transform="translate(-15.894 -7.949)" fill="#fff" />
        </svg>
    )
}

export default FrontYoutubeIcon